export const isPlural = (number: number): boolean => {
    if (number === 1) {
        return false;
    } else return true;
};
